export default __webpack_public_path__ + "static/media/Swiss-home-banner-liquid-m.52c52de1.jpg";